// Invoice translations (selectable language)
export const invoiceTranslations = {
    en: {
        invoice: "INVOICE",
        issueDateLabel: "Issue date",
        dueDateLabel: "Due date",
        currencyLabel: "Currency",
        customerLabel: "Client",
        description: "Description",
        amount: "Price",
        total: "Total",
        paymentInfoLabel: "Payment Information",
        paymentOption: "Payment option",
        noteLabel: "Note",
        variableSymbol: "Variable symbol",
        constantSymbol: "Constant symbol",
        account: "Account",
        iban: "IBAN",
        bicSwift: "BIC/SWIFT",
        bank: "Bank",
        quantity: "Amount",
        unit: "Unit",
        paymentOptions: "Payment Options",
        paymentDetails: "Payment Information",
        bankTransfer: "Bank Transfer",
        onlinePayment: "Online Payment",
        paymentLink: "Payment Link",
        cash: "Cash Payment",
        custom: "Custom",
        paymentUponDelivery: "Payment upon delivery or pickup",
        enterCustomPaymentDetails: "Enter custom payment details",
        paymentMethodBankingDetails: "Payment method and banking details",
        businessLogo: "Business Logo",
        website: "Website",
        websiteText: "Website Text",
        issuedBy: "Issued by",
        acceptedBy: "Accepted by",
        signature: "Signature",
        vatPayer: "VAT Payer",
        nonVatPayer: "Non-VAT Payer",
        notSpecified: "Not specified",
        identificationNumber: "Tax Identification Number",
        dic: "VAT Identification Number",
        czechSoleProprietor: "Natural person registered in the Czech Trade Register",
        taxSettings: "VAT Settings",
        enableVat: "Enable VAT",
        vatRate: "VAT Rate (%)",
        vat: "VAT",
        netAmount: "Net Amount",
        vatAmount: "VAT Amount",
        totalAmount: "Total Amount",
        discount: "Discount",
        discountPercent: "Discount (%)",
        applyDiscount: "Apply Discount",
        itemDiscount: "Item Discount",
        totalDiscount: "Total Discount",
        addCustomTax: "Add Custom Tax",
        taxName: "Tax Name",
        taxAmount: "Tax Amount",
        taxPercentage: "Tax Percentage",
        fixedAmount: "Fixed Amount",
        percentage: "Percentage",
        manageSavedItems: "Manage saved items",
    },
    cs: {
        invoice: "FAKTURA",
        issueDateLabel: "Datum vystavení",
        dueDateLabel: "Datum splatnosti",
        currencyLabel: "Měna",
        customerLabel: "Klient",
        description: "Popis",
        amount: "Částka",
        total: "Celkem",
        paymentInfoLabel: "Platební údaje",
        paymentOption: "Platební možnost",
        noteLabel: "Poznámka",
        variableSymbol: "Variabilní symbol",
        constantSymbol: "Konstantní symbol",
        account: "Účet",
        iban: "IBAN",
        bicSwift: "BIC/SWIFT",
        bank: "Banka",
        quantity: "Množství",
        unit: "Jednotka",
        paymentOptions: "Platební možnosti",
        paymentDetails: "Platební údaje",
        bankTransfer: "Bankovní převod",
        onlinePayment: "Online platba",
        paymentLink: "Platební odkaz",
        cash: "Hotovostní platba",
        custom: "Vlastní",
        paymentUponDelivery: "Platba při doručení nebo vyzvednutí",
        enterCustomPaymentDetails: "Zadejte vlastní platební údaje",
        paymentMethodBankingDetails: "Způsob platby a bankovní údaje",
        businessLogo: "Logo firmy",
        website: "Webové stránky",
        websiteText: "Text webových stránek",
        issuedBy: "Vystavil",
        acceptedBy: "Přijal",
        signature: "Podpis",
        vatPayer: "Plátce DPH",
        nonVatPayer: "Neplátce DPH",
        notSpecified: "Nespecifikováno",
        identificationNumber: "IČO",
        dic: "DIČ",
        czechSoleProprietor: "Fyzická osoba zapsaná v živnostenském rejstříku",
        taxSettings: "Nastavení DPH",
        enableVat: "Povolit DPH",
        vatRate: "Sazba DPH (%)",
        vat: "DPH",
        netAmount: "Částka bez DPH",
        vatAmount: "Částka DPH",
        totalAmount: "Celková částka",
        discount: "Sleva",
        discountPercent: "Sleva (%)",
        applyDiscount: "Použít slevu",
        itemDiscount: "Sleva na položku",
        totalDiscount: "Celková sleva",
        addCustomTax: "Přidat vlastní daň",
        taxName: "Název daně",
        taxAmount: "Částka daně",
        taxPercentage: "Procento daně",
        fixedAmount: "Pevná částka",
        percentage: "Procento",
        manageSavedItems: "Spravovat uložené položky",
    },
    sk: {
        invoice: "FAKTÚRA",
        issueDateLabel: "Dátum vystavenia",
        dueDateLabel: "Dátum splatnosti",
        currencyLabel: "Mena",
        customerLabel: "Klient",
        description: "Popis",
        amount: "Suma",
        total: "Celkom",
        paymentInfoLabel: "Platobné údaje",
        paymentOption: "Platobná možnosť",
        noteLabel: "Poznámka",
        variableSymbol: "Variabilný symbol",
        constantSymbol: "Konštantný symbol",
        account: "Účet",
        iban: "IBAN",
        bicSwift: "BIC/SWIFT",
        bank: "Banka",
        quantity: "Množstvo",
        unit: "Jednotka",
        paymentOptions: "Platobné možnosti",
        paymentDetails: "Platobné údaje",
        bankTransfer: "Bankový prevod",
        onlinePayment: "Online platba",
        paymentLink: "Platobný odkaz",
        cash: "Hotovostná platba",
        custom: "Vlastná",
        paymentUponDelivery: "Platba pri doručení alebo vyzdvihnutí",
        enterCustomPaymentDetails: "Zadajte vlastné platobné údaje",
        paymentMethodBankingDetails: "Spôsob platby a bankové údaje",
        businessLogo: "Logo firmy",
        website: "Webové stránky",
        websiteText: "Text webových stránok",
        issuedBy: "Vystavil",
        acceptedBy: "Prijal",
        signature: "Podpis",
        vatPayer: "Plátca DPH",
        nonVatPayer: "Neplátca DPH",
        notSpecified: "Nešpecifikované",
        identificationNumber: "IČO",
        dic: "DIČ",
        czechSoleProprietor: "Fyzická osoba zapísaná v živnostenskom registri",
        taxSettings: "Nastavenie DPH",
        enableVat: "Povoliť DPH",
        vatRate: "Sadzba DPH (%)",
        vat: "DPH",
        netAmount: "Suma bez DPH",
        vatAmount: "Suma DPH",
        totalAmount: "Celková suma",
        discount: "Zľava",
        discountPercent: "Zľava (%)",
        applyDiscount: "Použiť zľavu",
        itemDiscount: "Zľava na položku",
        totalDiscount: "Celková zľava",
        addCustomTax: "Pridať vlastnú daň",
        taxName: "Názov dane",
        taxAmount: "Suma dane",
        taxPercentage: "Percento dane",
        fixedAmount: "Pevná suma",
        percentage: "Percento",
        manageSavedItems: "Spravovať uložené položky",
    },
    ru: {
        invoice: "СЧЕТ",
        issueDateLabel: "Дата выставления",
        dueDateLabel: "Срок оплаты",
        currencyLabel: "Валюта",
        customerLabel: "Клиент",
        description: "Описание",
        amount: "Сумма",
        total: "Итого",
        paymentInfoLabel: "Платежная информация",
        paymentOption: "Вариант оплаты",
        noteLabel: "Примечание",
        variableSymbol: "Переменный символ",
        constantSymbol: "Постоянный символ",
        account: "Счет",
        iban: "IBAN",
        bicSwift: "BIC/SWIFT",
        bank: "Банк",
        quantity: "Количество",
        unit: "Единица",
        paymentOptions: "Варианты оплаты",
        paymentDetails: "Платежная информация",
        bankTransfer: "Банковский перевод",
        onlinePayment: "Онлайн платеж",
        paymentLink: "Ссылка для оплаты",
        cash: "Наличный платеж",
        custom: "Другой",
        paymentUponDelivery: "Оплата при доставке или получении",
        enterCustomPaymentDetails: "Введите детали платежа",
        paymentMethodBankingDetails: "Способ оплаты и банковские реквизиты",
        businessLogo: "Логотип компании",
        website: "Веб-сайт",
        websiteText: "Текст веб-сайта",
        issuedBy: "Выставил",
        acceptedBy: "Принял",
        signature: "Подпись",
        vatPayer: "Плательщик НДС",
        nonVatPayer: "Неплательщик НДС",
        notSpecified: "Не указано",
        identificationNumber: "IČO",
        dic: "DIČ",
        czechSoleProprietor: "Физическое лицо, зарегистрированное в Торговом реестре Чехии",
        taxSettings: "Настройки НДС",
        enableVat: "Включить НДС",
        vatRate: "Ставка НДС (%)",
        vat: "НДС",
        netAmount: "Сумма без НДС",
        vatAmount: "Сумма НДС",
        totalAmount: "Общая сумма",
        discount: "Скидка",
        discountPercent: "Скидка (%)",
        applyDiscount: "Применить скидку",
        itemDiscount: "Скидка на товар",
        totalDiscount: "Общая скидка",
        addCustomTax: "Добавить налог",
        taxName: "Название налога",
        taxAmount: "Сумма налога",
        taxPercentage: "Процент налога",
        fixedAmount: "Фиксированная сумма",
        percentage: "Процент",
        manageSavedItems: "Управление сохраненными позициями",
    },
    uk: {
        invoice: "РАХУНОК",
        issueDateLabel: "Дата виставлення",
        dueDateLabel: "Термін оплати",
        currencyLabel: "Валюта",
        customerLabel: "Клієнт",
        description: "Опис",
        amount: "Сума",
        total: "Разом",
        paymentInfoLabel: "Платіжна інформація",
        paymentOption: "Варіант оплати",
        noteLabel: "Примітка",
        variableSymbol: "Змінний символ",
        constantSymbol: "Постійний символ",
        account: "Рахунок",
        iban: "IBAN",
        bicSwift: "BIC/SWIFT",
        bank: "Банк",
        quantity: "Кількість",
        unit: "Одиниця",
        paymentOptions: "Варіанти оплати",
        paymentDetails: "Платіжна інформація",
        bankTransfer: "Банківський переказ",
        onlinePayment: "Онлайн платіж",
        paymentLink: "Посилання для оплати",
        cash: "Готівковий платіж",
        custom: "Інший",
        paymentUponDelivery: "Оплата при доставці або отриманні",
        enterCustomPaymentDetails: "Введіть деталі платежу",
        paymentMethodBankingDetails: "Спосіб оплати та банківські реквізити",
        businessLogo: "Логотип компанії",
        website: "Веб-сайт",
        websiteText: "Текст веб-сайту",
        issuedBy: "Виставив",
        acceptedBy: "Прийняв",
        signature: "Підпис",
        vatPayer: "Платник ПДВ",
        nonVatPayer: "Неплатник ПДВ",
        notSpecified: "Не вказано",
        identificationNumber: "IČO",
        dic: "DIČ",
        czechSoleProprietor: "Фізична особа, зареєстрована в Торговому реєстрі Чехії",
        taxSettings: "Налаштування ПДВ",
        enableVat: "Увімкнути ПДВ",
        vatRate: "Ставка ПДВ (%)",
        vat: "ПДВ",
        netAmount: "Сума без ПДВ",
        vatAmount: "Сума ПДВ",
        totalAmount: "Загальна сума",
        discount: "Знижка",
        discountPercent: "Знижка (%)",
        applyDiscount: "Застосувати знижку",
        itemDiscount: "Знижка на товар",
        totalDiscount: "Загальна знижка",
        addCustomTax: "Додати податок",
        taxName: "Назва податку",
        taxAmount: "Сума податку",
        taxPercentage: "Відсоток податку",
        fixedAmount: "Фіксована сума",
        percentage: "Відсоток",
        manageSavedItems: "Управління збереженими позиціями",
    },
    de: {
        invoice: "RECHNUNG",
        issueDateLabel: "Rechnungsdatum",
        dueDateLabel: "Fälligkeitsdatum",
        currencyLabel: "Währung",
        customerLabel: "Kunde",
        description: "Beschreibung",
        amount: "Betrag",
        total: "Gesamt",
        paymentInfoLabel: "Zahlungsinformationen",
        paymentOption: "Zahlungsoption",
        noteLabel: "Hinweis",
        variableSymbol: "Verwendungszweck",
        constantSymbol: "Konstanter Symbol",
        account: "Konto",
        iban: "IBAN",
        bicSwift: "BIC/SWIFT",
        bank: "Bank",
        quantity: "Menge",
        unit: "Einheit",
        paymentOptions: "Zahlungsoptionen",
        paymentDetails: "Zahlungsinformationen",
        bankTransfer: "Banküberweisung",
        onlinePayment: "Online-Zahlung",
        paymentLink: "Zahlungslink",
        cash: "Barzahlung",
        custom: "Benutzerdefiniert",
        paymentUponDelivery: "Zahlung bei Lieferung oder Abholung",
        enterCustomPaymentDetails: "Geben Sie benutzerdefinierte Zahlungsdetails ein",
        paymentMethodBankingDetails: "Zahlungsmethode und Bankverbindung",
        businessLogo: "Firmenlogo",
        website: "Website",
        websiteText: "Website-Text",
        issuedBy: "Ausgestellt von",
        acceptedBy: "Angenommen von",
        signature: "Unterschrift",
        vatPayer: "USt-Pflichtig",
        nonVatPayer: "Nicht USt-pflichtig",
        notSpecified: "Nicht angegeben",
        identificationNumber: "IČO",
        dic: "DIČ",
        czechSoleProprietor: "Natürliche Person, eingetragen im tschechischen Gewerberegister",
        taxSettings: "USt-Einstellungen",
        enableVat: "USt aktivieren",
        vatRate: "USt-Satz (%)",
        vat: "USt",
        netAmount: "Nettobetrag",
        vatAmount: "USt-Betrag",
        totalAmount: "Gesamtbetrag",
        discount: "Rabatt",
        discountPercent: "Rabatt (%)",
        applyDiscount: "Rabatt anwenden",
        itemDiscount: "Artikelrabatt",
        totalDiscount: "Gesamtrabatt",
        addCustomTax: "Benutzerdefinierte Steuer hinzufügen",
        taxName: "Steuername",
        taxAmount: "Steuerbetrag",
        taxPercentage: "Steuerprozentsatz",
        fixedAmount: "Fester Betrag",
        percentage: "Prozent",
        manageSavedItems: "Gespeicherte Artikel verwalten",
    }
};

